import axios, { AxiosRequestConfig, Method as AxiosMethod, AxiosResponse } from 'axios'
import store from '@/store'
import { MutationsTypes } from '@/store/modules/user'
import router from '@/router'

import { format } from '@/utils/string'
import { Notification } from 'element-ui'
import { get as getValue } from 'lodash'
import { Token } from '@/common/token'
import { getlang } from '@/common/storage'

const axiosInstance = axios.create()

interface RequestOption {
    url?: string;
    method?: AxiosMethod;
    headers?: any;
    data?: any;
    paramsData?:any
}

export enum Method {
    Post = 'POST',
    Get = 'GET',
    Put = 'PUT',
    Delete = 'DELETE',
    PATCH = 'PATCH'
}

const codeMessage = {
    200: '操作成功',
    201: '新建或修改数据成功',
    202: '一个请求已经进入后台排队（异步任务）',
    204: '删除数据成功。',
    400: '参数错误',
    401: '需要用户验证',
    403: '用户无权限',
    404: '资源不存在',
    405: '不支持的操作方法',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的',
    422: '当创建一个对象时，发生一个验证错误',
    500: '服务器内部错误',
    502: '应用程序错误',
    503: '维护中',
    504: '网关超时'
}

function errorShow (status, errorText) {
    // 处理，限制在401状态下显示弹窗个数
    if (status === 401) {
        const localErrorText = sessionStorage.getItem('localErrorText')
        let now = new Date().getTime()
        sessionStorage.setItem('localErrorText', now + '')
        if (localErrorText && now - Number(localErrorText) < 20000) {
            return
        }
    }
    Notification.error({
        title: '请求错误:',
        message: errorText
    })
}

function markUrl (link:string, data:any) {
  if (typeof data !== 'undefined' && data !== '') {
    var paramArr:any = []
    for (var key in data) {
      paramArr.push(key + '=' + data[key])
    }
    link += '?' + paramArr.join('&')
  }
  return link
}

export function request<T> (url: string, options: RequestOption = {}): Promise<{ data?: T, error?: any, response?: any}> {
    let config = { ...options }
    config.headers = options.headers || {}
    config.url = url

    const type = options.method

    const token = <Token>store.state.user.token
    const lang = getlang()
    //         config.headers['Authorization'] = `Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIwMSIsImlhdCI6MTczMjY4MDcyNSwiZXhwIjoxNzMyNzE2NzI1fQ.h-ZUhw8z_-Flb6pNImyVQmT2ThnMubNyqnjFQuoqoeQ`
    // if (token) {
    //     config.headers['Authorization'] = `Bearer ${token.value}`
    // }

    if (lang) {
        config.headers['lang'] = lang === 'en-US' ? 'en_US' : 'zh_CN'
    }

    if (type === 'POST' || type === 'DELETE' || type === 'PUT' || type === 'PATCH') {
        config.headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            ...config.headers
        }
    }

    return new Promise((resolve, reject) => {
        axiosInstance.request(config)
            .then((response) => {
                return new Promise<AxiosResponse<any>>((interResolve, interReject) => {
                    if (response.status >= 200 && response.status < 300) {
                        interResolve(response)
                    } else {
                        interReject(response)
                    }
                })
            })
            .then((response) => {
                resolve({
                    data: response.data,
                    response: response
                })
            })
            .catch((e) => {
                const status = getValue(e, 'response.status')
                if (status === 401) {
                    const errorText = getValue(codeMessage, status, getValue(e, 'statusText', ''))
                    errorShow(status, errorText)

                    store.commit(`user/${MutationsTypes.Logout}`)
                    router.push('/login')
                } else {
                    const errorText = getValue(e, 'response.data.error.message', getValue(codeMessage, status, getValue(e, 'statusText', '')))
                    errorShow(status, errorText)
                }

                resolve({
                    error: e
                })
            })
    })
}

export function callApi<T> ({ url, type }: { url: string, type: AxiosMethod}, options: RequestOption = {}) {
    let newUrl = url
    if (options.paramsData) {
      newUrl = markUrl(newUrl, options.paramsData)
    }
    if (type === Method.Get && options.data) {
        newUrl = format(url, options.data)
    }
    options.method = type
    return request<T>(newUrl, options)
}

export function get<T> (url: string, options: RequestOption = {}) {
    options.method = Method.Get
    return request<T>(url, options)
}

export default request
